import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="text-2xl font-bold text-white mb-6 block">
              Code Splash
            </Link>
            <p className="text-gray-400 mb-6">
            Friendly interfaces, lightning-fast performance, and no surprises..
            </p>
            <div className="text-gray-400">
              <p className="font-semibold text-white mb-2">WE ARE AVAILABLE</p>
              <p>MON-SAT: 09.00 AM TO 6.30 PM</p>
            </div>
          </div>

          {/* Useful Links */}
          {/* <div>
            <h3 className="text-xl font-bold mb-6">Useful Links</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/case-studies" className="text-gray-400 hover:text-white transition-colors">
                  Our Portfolio
                </Link>
              </li>
              <li>
                <Link to="/services/ecommerce" className="text-gray-400 hover:text-white transition-colors">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  Our Team
                </Link>
              </li>
            </ul>
          </div> */}

          {/* Contact Info */}
          <div>
            <h3 className="text-xl font-bold mb-6">Contact Us</h3>
            <ul className="space-y-3 text-gray-400">
              <li>
                <a href="mailto:support@codesplashdesigns.com" className="hover:text-white transition-colors">
                  support@codesplashdesigns.com
                </a>
              </li>
              <li>
                <p>1372 Peachtree Street</p>
                <p>Atlanta, GA 30309</p>
              </li>
            </ul>
          </div>

          {/* Newsletter */}
          <div>
            <h3 className="text-xl font-bold mb-6">Subscribe Newsletter</h3>
            <form className="space-y-4">
              <input
                type="email"
                placeholder="Enter your email"
                className="w-full px-4 py-3 bg-gray-800 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <button
                type="submit"
                className="w-full bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg transition-colors"
              >
                Sign Up
              </button>
            </form>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>Copyright ©{new Date().getFullYear()} Code Splash. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 